import { render, staticRenderFns } from "./CustomerVoicePostShow.vue?vue&type=template&id=028f3019&scoped=true&"
import script from "./CustomerVoicePostShow.vue?vue&type=script&lang=js&"
export * from "./CustomerVoicePostShow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVoicePostShow.vue?vue&type=style&index=0&id=028f3019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f3019",
  null
  
)

export default component.exports